import ApiService from '../_shared/api/apiService';
import renderLocale from '../_shared/helpers/renderLocale';
import Singleton from '../Singleton';

export default class PostSaleService extends Singleton<PostSaleService> {
  static getShippingEstimate = async (tradeId: number) => {
    const client = await ApiService();
    let shippingEstimateResponse;

    try {
      shippingEstimateResponse = await client.apis[
        'post-sale'
      ].getShippingEstimate1({
        request: {
          request: {
            tradeId
          }
        }
      });
    } catch (e) {
      // TODO handle exceptions
    }
    return shippingEstimateResponse?.body;
  };

  static getShippingEstimateV2 = async (tradeId: number, dealerId: number) => {
    const client = await ApiService();

    const shippingEstimateResponse = await client.apis.shipping.getShippingEstimate2(
      {
        request: {
          tradeId,
          dealerId
        }
      }
    );

    return shippingEstimateResponse?.body;
  };

  static getRateInfoTermsAndConditions = async (
    isShippingPromotion: boolean
  ) => {
    const client = await ApiService();
    const lang = renderLocale();

    const rateInfoResponse = await client.apis[
      'post-sale'
    ].getRateInfoTermsAndConditions({
      request: {
        request: {
          isShippingPromotion,
          lang
        }
      }
    });

    return rateInfoResponse?.body;
  };
}
